const TableSkeleton: React.FC = () => {
  return (
    <div className="px-6 py-4 animate-pulse">
      <div className="grid grid-cols-12 gap-4 items-center">
        {/* Customer skeleton */}
        <div className="col-span-3">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gray-200 rounded-lg"></div>
            <div className="space-y-2">
              <div className="h-4 bg-gray-200 rounded w-24"></div>
              <div className="h-3 bg-gray-200 rounded w-20"></div>
            </div>
          </div>
        </div>

        {/* System Details skeleton */}
        <div className="col-span-2">
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-16"></div>
            <div className="h-3 bg-gray-200 rounded w-20"></div>
          </div>
        </div>

        {/* Sales Rep skeleton */}
        <div className="col-span-2">
          <div className="flex items-center">
            <div className="w-3 h-3 bg-gray-200 rounded mr-1.5"></div>
            <div className="h-4 bg-gray-200 rounded w-20"></div>
          </div>
        </div>

        {/* Amount skeleton */}
        <div className="col-span-2">
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded w-20"></div>
            <div className="h-3 bg-gray-200 rounded w-12"></div>
          </div>
        </div>

        {/* Status skeleton */}
        <div className="col-span-2">
          <div className="h-6 bg-gray-200 rounded-full w-16"></div>
        </div>

        {/* Actions skeleton */}
        <div className="col-span-1">
          <div className="h-7 bg-gray-200 rounded w-12"></div>
        </div>
      </div>
    </div>
  );
};
export default TableSkeleton;
